import StructureIdSearch from "./StructureIdSearch.js";

export default class StructureIdList {
     /** {@type StructureId[]} */
    #ids;

     /** @param {StructureId[]} ids */
    constructor(ids) {
        if(!Array.isArray(ids))
            throw new Error("Not an array: " + JSON.stringify(ids));
        this.#ids = ids;
    }

    get(idx) {
        return this.#ids[idx];
    }

    /** @return {string[]} */
    toUids() {
        const result = [];
        for (const next of this.#ids)
            result.push(next.id);
        return result;
    }

    /** @return {string[]} */
    getParents(){
        const result = [];
        for (const next of this.#ids)
            result.push(next.parent);
        return result;
    }

    /** @param {StructureId} id */
    addForm(id){
        this.#ids.push(id)
    }

    /**
     * @param {StructureId} structureId
     * @returns {number}
     */
    indexOf(structureId) {
        return this.#ids.indexOf(structureId);
    }
    /**
     * @param {boolean} withStereo
     * @param {boolean} withProtonation
     * @return StructureIdSearch[]
     */
    toDismantled(withStereo = true, withProtonation = true) {
        const result = [];
        for (const id of this.#ids)
            result.push(StructureIdSearch.frommId(id, withStereo, withProtonation));
        return result;
    }
    size() {
        return this.#ids.length;
    }

    /**
     * @param {StructureId[]} structureIds
     * @returns {StructureIdList}
     */
    with(structureIds) {
        const result = [...this.#ids];
        result.push(...structureIds);
        return new StructureIdList(result);
    }

    /** @param {StructureId} id */
    deleteForm(id){
        this.#ids.splice(this.indexOf(id), 1)
    }
}